import http from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type { PresignedUrlReq, PresignedUrlResp } from '@/types/upload'

/**
 * 获取火山云 TOS 上传预签名地址。
 * 路径：`POST /app/upload/presigned-url`（与后端 AppUploadController 对齐）。
 *
 * @returns 包含 objectKey / signedUrl / fileUrl 的对象；后续 PUT 到 signedUrl 即可。
 */
export async function getPresignedUrl(
  payload: PresignedUrlReq,
): Promise<ApiResponse<PresignedUrlResp>> {
  const { data } = await http.post<ApiResponse<PresignedUrlResp>>(
    '/app/upload/presigned-url',
    payload,
  )
  return data
}
